/**
 * AGC: Backend URL utilities to normalize API endpoints across environments
 * AGC: Ensures production builds always prioritize the deployed Cloud Run URL
 */

const DEFAULT_PROD_URL = 'https://origami-backend-490617898031.us-central1.run.app'
const DEFAULT_LOCAL_URL = 'http://localhost:3001'

/**
 * AGC: Resolve the preferred backend base URL depending on environment
 */
export const getBackendBaseUrl = (): string => {
  const env = typeof import.meta !== 'undefined' ? import.meta.env : undefined
  const isProd = env?.PROD ?? false

  if (isProd) {
    return env?.VITE_BACKEND_URL || DEFAULT_PROD_URL
  }

  return env?.VITE_BACKEND_URL_DEV || env?.VITE_BACKEND_URL || DEFAULT_LOCAL_URL
}

/**
 * AGC: Build a full backend URL with optional path (avoids double slashes)
 */
export const buildBackendUrl = (path = ''): string => {
  const base = getBackendBaseUrl().replace(/\/$/, '')
  if (!path) {
    return base
  }

  const trimmedPath = path.replace(/^\//, '')
  return `${base}/${trimmedPath}`
}


